/**
 * Product mockups. Paste the hosted image URL in each slot.
 * While a slot is empty the page draws a built-in illustration in the
 * product's palette, so nothing ever shows as a broken image.
 */
export const images = {
  /** Main pack mockup (hero) */
  hero: 'https://cdn.magicpatterns.com/uploads/e5jxCv1eg6rqpt1C8tWgNu/MOVement-Photorealistic-product-lineup-shot-of-si.png',
  /** Main pack mockup (pricing card) — can reuse the hero image */
  pricing: 'https://cdn.magicpatterns.com/uploads/e5jxCv1eg6rqpt1C8tWgNu/MOVement-Photorealistic-product-lineup-shot-of-si.png',
  /** Bonus 1 to 5 mockups, in order */
  bonuses: [
    'https://cdn.magicpatterns.com/uploads/dvy7nJWR43T2oPuHgGvDqQ/DPS42_-_Bono_1_-_Pivot_Cards.png',
    'https://cdn.magicpatterns.com/uploads/eScdy1Hcjtui2Eirg3HpE8/DPS42_-_Bono_2_-_Group_Need_Finder.png',
    'https://cdn.magicpatterns.com/uploads/vVHBvmU4yRyYnygR9pPHwD/DPS42_-_Bono_3_-_Room_Setup_Blueprints.png',
    'https://cdn.magicpatterns.com/uploads/a7738gWt2mzLXmqz2JEcMZ/DPS42_-_Bono_4_-_The_Facilitator_Reset.png',
    'https://cdn.magicpatterns.com/uploads/bhpS4UJukE6RJ312swcg7s/DPS42_-_Bono_5_-_Your_First_Two_Weeks.png',
  ],
}
